import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "d-flex flex-row align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "avatar-img flex-shrink-0"
}
const _hoisted_4 = {
  key: 1,
  class: "avatar-img flex-shrink-0",
  src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
  alt: ""
}
const _hoisted_5 = { class: "message-row d-flex flex-column flex-grow-1" }
const _hoisted_6 = { class: "message-title flex-grow-1" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "profile-meta flex-shrink-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "message-body" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_auth_image = _resolveDirective("auth-image")!

  return (_ctx.otherParty)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: '/messages/'+_ctx.otherParty.id,
        id: _ctx.otherParty.id,
        class: "private-message-wrap"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.otherParty?.id !=='00000000-0000-0000-0000-000000000000')
                ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_3, null, 512)), [
                    [_directive_auth_image, _ctx.imagePrefix + _ctx.otherParty.id]
                  ])
                : _createCommentVNode("", true),
              (_ctx.otherParty?.id ==='00000000-0000-0000-0000-000000000000')
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.otherParty.givenName === "" ? _ctx.otherParty.email : "") + _toDisplayString(_ctx.otherParty.givenName) + " " + _toDisplayString(_ctx.otherParty.surName), 1),
                _createElementVNode("div", {
                  class: "message-excerpt",
                  innerHTML: _ctx.msg.message
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.dateTime2(_ctx.msg.createdAt)), 1)
              ])
            ])
          ]),
          _hoisted_10
        ]),
        _: 1
      }, 8, ["to", "id"]))
    : _createCommentVNode("", true)
}